import firebase from 'firebase/app';
import 'firebase/auth';

let firebaseConfig = {};

if(document.URL.indexOf("dev") !== -1 || document.URL.indexOf("localhost") !== -1) {
  firebaseConfig = {
    apiKey: "AIzaSyAAV_Ajq1FAASeEdKt3z7fMYdDi-9HU-UY",
    authDomain: "devmappser.firebaseapp.com",
    databaseURL: "https://devmappser.firebaseio.com",
    projectId: "devmappser",
    storageBucket: "devmappser.appspot.com",
    messagingSenderId: "389384347367",
    appId: "1:389384347367:web:14f76358d8fcb0d56fcc42",
    measurementId: "G-BMCTB7Y2TG"
  }
} else {
  firebaseConfig = {
    apiKey: "AIzaSyDIB-DqJwafYbwwVxKwKW6ADhprRtQMMP0",
    authDomain: "cnesimulacro.firebaseapp.com",
    databaseURL: "https://cnesimulacro.firebaseio.com",
    projectId: "cnesimulacro",
    storageBucket: "cnesimulacro.appspot.com",
    messagingSenderId: "541518476516",
    appId: "1:541518476516:web:4a7d7e95c04308ab85a8f1",
    measurementId: "G-BF8ZTQSMBP"
} 
}

/*const firebaseConfig = {
    apiKey: "AIzaSyAAV_Ajq1FAASeEdKt3z7fMYdDi-9HU-UY",
    authDomain: "devmappser.firebaseapp.com",
    databaseURL: "https://devmappser.firebaseio.com",
    projectId: "devmappser",
    storageBucket: "devmappser.appspot.com",
    messagingSenderId: "389384347367",
    appId: "1:389384347367:web:14f76358d8fcb0d56fcc42",
    measurementId: "G-BMCTB7Y2TG"
  };*/

  /*const firebaseConfig = {
    apiKey: "AIzaSyDIB-DqJwafYbwwVxKwKW6ADhprRtQMMP0",
    authDomain: "cnesimulacro.firebaseapp.com",
    databaseURL: "https://cnesimulacro.firebaseio.com",
    projectId: "cnesimulacro",
    storageBucket: "cnesimulacro.appspot.com",
    messagingSenderId: "541518476516",
    appId: "1:541518476516:web:4a7d7e95c04308ab85a8f1",
    measurementId: "G-BF8ZTQSMBP"
  };*/

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export default firebaseApp;
